module.exports = __webpack_public_path__ + "img/瑞士弗里堡大学.8004b005.png";